import { useEffect, useState } from "react";
import ProgressBar from "./ProgressBar";
import { ITimedProgressBarProperties } from "../../properties/BarProperties";

const TimedProgressBar = ({
  title,
  startTimer,
  showRemainingTime,
  totalTimeInSeconds,
  remainingTimeInSeconds,
  handleOnTimerEnds,
}: ITimedProgressBarProperties) => {
  const [timerRemainingTimeInSeconds, setTimerRemainingTimeInSeconds] =
    useState(remainingTimeInSeconds);
  const [timerIntervalId, setTimerIntervalId] = useState<ReturnType<typeof setInterval> | null>(null);
  let timerRemainingTimeInSecondsValue: number = 999999999999999;

  useEffect(() => {
    timerRemainingTimeInSecondsValue = remainingTimeInSeconds;
    setTimerRemainingTimeInSeconds(timerRemainingTimeInSeconds);
    if (timerIntervalId) {
      clearInterval(timerIntervalId);
    }
    if (startTimer) {
      const currentTimerIntervalId = setInterval(() => {
        timerRemainingTimeInSecondsValue =
          timerRemainingTimeInSecondsValue - 0.05;
        setTimerRemainingTimeInSeconds(timerRemainingTimeInSecondsValue);
      }, 50);
      setTimerIntervalId(currentTimerIntervalId);
    } else {
      if (timerIntervalId) {
        clearInterval(timerIntervalId);
        setTimerIntervalId(null);
      }
    }
  }, [remainingTimeInSeconds, startTimer]);

  useEffect(() => {
    if (timerRemainingTimeInSeconds < 0) {
      if (timerIntervalId) {
        clearInterval(timerIntervalId);
      }
      handleOnTimerEnds(startTimer);
    }
  }, [timerRemainingTimeInSeconds]);

  return (
    <ProgressBar
      title={title}
      showRemainingTime={showRemainingTime}
      remainingTimeInSeconds={timerRemainingTimeInSeconds}
      totalTimeInSeconds={totalTimeInSeconds}
    />
  );
};

export default TimedProgressBar;
